package com.ijoin.deeplink

import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.asSharedFlow

/**
 * Central handler for deep links across all platforms
 */
object DeepLinkHandler {
    private val _deepLinks = MutableSharedFlow<DeepLink>(extraBufferCapacity = 1)
    val deepLinks: SharedFlow<DeepLink> = _deepLinks.asSharedFlow()

    private var pendingDeepLink: DeepLink? = null

    /**
     * Handle an incoming deep link URL
     */
    fun handleUrl(url: String) {
        val deepLink = DeepLinkParser.parse(url)
        if (deepLink != null) {
            handleDeepLink(deepLink)
        }
    }

    /**
     * Handle an incoming deep link
     */
    fun handleDeepLink(deepLink: DeepLink) {
        pendingDeepLink = deepLink
        _deepLinks.tryEmit(deepLink)
    }

    /**
     * Get and clear pending deep link (for initial app launch)
     */
    fun consumePendingDeepLink(): DeepLink? {
        val pending = pendingDeepLink
        pendingDeepLink = null
        return pending
    }

    /**
     * Peek pending deep link without clearing it.
     */
    fun peekPendingDeepLink(): DeepLink? = pendingDeepLink

    /**
     * Check if there's a pending deep link
     */
    fun hasPendingDeepLink(): Boolean = pendingDeepLink != null
}
